import { defineEffect } from '../../../core/effect';
import { spec } from '../fx/battle';

/** 状況 `battle_direct`（組み立ては `../fx/battle.js`。arcade はどの状況も同じ絵） */
export default defineEffect({ situation: 'battle_direct', role: 'effect', ...spec }, 'battle_direct_effect.js');
